// You can write more code here

import { PhaserAudioManager } from '@/game/GameComponents/PhaserGame/Utils/PhaserAudioManager';
import {
  Reward,
  RewardType,
} from '@/game/GameComponents/PhaserGame/Utils/RewardsManager';
import { getGameName } from '@/game/gameHelpers';

/* START OF COMPILED CODE */

export default class WorldRewardFeedback extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // floater
    const floater = scene.add.container(0, 0);
    this.add(floater);

    // rewardImage
    const rewardImage = scene.add.image(-2, 0, 'hud-icons', 95);
    rewardImage.setOrigin(1, 0.5);
    floater.add(rewardImage);

    // rewardText
    const rewardText = scene.add.bitmapText(0, 0, 'Aronui', '+100');
    rewardText.setOrigin(0, 0.5);
    rewardText.tintTopLeft = 15130076;
    rewardText.tintTopRight = 15130076;
    rewardText.tintBottomLeft = 15130076;
    rewardText.tintBottomRight = 15130076;
    rewardText.text = '+100';
    rewardText.fontSize = -14;
    rewardText.dropShadowX = 1;
    rewardText.dropShadowY = 1;
    floater.add(rewardText);

    this.rewardImage = rewardImage;
    this.rewardText = rewardText;
    this.floater = floater;

    /* START-USER-CTR-CODE */
    this.initialize();
    this.setDepth(999);
    /* END-USER-CTR-CODE */
  }

  private rewardImage: Phaser.GameObjects.Image;
  private rewardText: Phaser.GameObjects.BitmapText;
  private floater: Phaser.GameObjects.Container;

  /* START-USER-CODE */

  private parent?: Phaser.GameObjects.Container;

  initialize() {
    const yOffset = -30;
    this.floater.setY(yOffset);
    this.scene.tweens.add({
      targets: this.floater,
      x: 0,
      y: -30 + yOffset,
      duration: 3000,
      alpha: 0,
      ease: 'easeInLinear',
      onComplete: () => {
        this.destroy();
      },
    });

    PhaserAudioManager.playSFX(this.scene, 'reward-world-popup');

    this.scene.events.on('prerender', this.update, this);
    this.scene.events.on('pause', () => {
      this.destroy();
    });
  }

  setParent(parent: Phaser.GameObjects.Container) {
    this.parent = parent;
  }

  setReward(reward: Reward) {
    if (reward.rubies > 0) {
      this.rewardImage.setTexture('hud-icons', 95);
      this.rewardText.setText(`+${reward.rubies}`);
    }
    if (reward.rewardType === RewardType.MINIGAME_MASTERY) {
      if (!reward.masteryGame) {
        console.error(
          'tried to give mastery reward: ',
          reward,
          ' with no minigame defined.',
        );
        return;
      }
      this.rewardImage.setScale(0.5);
      this.rewardImage.setTexture(reward.masteryGame);
      this.rewardText.setFont('Aronui');
      this.rewardText.setFontSize(this.rewardText.fontSize + 2);
      this.rewardText.setText(getGameName(reward.masteryGame) || '');
    }
  }

  update() {
    if (this.parent) {
      this.setPosition(this.parent.x, this.parent.y);
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
